import Main from "../components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";
import FeeTypesManagement from "../pages/finance/fees/FeeTypesManagement";
import FeeStructuresManagement from "../pages/finance/fees/FeeStructuresManagement";
import CustomFeesManagement from "../pages/finance/custom-fees/CustomFeesManagement";
import FeeAssignmentsView from "../pages/finance/assignments/FeeAssignmentsView";
import TransportFeesManagement from "../pages/finance/transport-fees/TransportFeesManagement";
import PaymentsManagement from "../pages/finance/payments/PaymentsManagement";
import ReconciliationManagement from "../pages/finance/reconciliation/ReconciliationManagement";
import BudgetManagement from "../pages/finance/budget/BudgetManagement";
import RequisitionManagement from "../pages/finance/requisition/RequisitionManagement";
import PayrollManagement from "../pages/finance/payroll/PayrollManagement";
import PayrollRunsManagement from "../pages/finance/payroll/PayrollRunsManagement";
import PayrollReports from "../pages/finance/payroll/PayrollReports";
import PayrollDashboard from "../pages/finance/payroll/PayrollDashboard";
import PayrollSecurityAudit from "../pages/finance/payroll/PayrollSecurityAudit";
import FinancialReports from "../pages/finance/reports/FinancialReports";
import StudentsManagement from "../pages/finance/students/StudentsManagement";
import AdmissionFeeManagement from "../pages/finance/admission/AdmissionFeeManagement";
import BursaryGiantsManagement from "../pages/academics/bursary_giants/BursaryGiantsManagement";

const financeRoutes = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "finance/fees/fee-types",
        element: (
          <ProtectedRoute>
            <FeeTypesManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/fees/fee-structures",
        element: (
          <ProtectedRoute>
            <FeeStructuresManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/custom-fees",
        element: (
          <ProtectedRoute>
            <CustomFeesManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/fees/assignments",
        element: (
          <ProtectedRoute>
            <FeeAssignmentsView />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/transport-fees",
        element: (
          <ProtectedRoute>
            <TransportFeesManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/payments",
        element: (
          <ProtectedRoute>
            <PaymentsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/reconciliation",
        element: (
          <ProtectedRoute>
            <ReconciliationManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/budgets",
        element: (
          <ProtectedRoute>
            <BudgetManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/requisitions",
        element: (
          <ProtectedRoute>
            <RequisitionManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/payroll",
        element: (
          <ProtectedRoute>
            <PayrollManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/reports",
        element: (
          <ProtectedRoute>
            <FinancialReports />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/students",
        element: (
          <ProtectedRoute>
            <StudentsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/admission",
        element: (
          <ProtectedRoute>
            <AdmissionFeeManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/payroll/audit",
        element: (
          <ProtectedRoute>
            <PayrollSecurityAudit />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/payroll/dashboard",
        element: (
          <ProtectedRoute>
            <PayrollDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/payroll/runs",
        element: (
          <ProtectedRoute>
            <PayrollRunsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/payroll/reports",
        element: (
          <ProtectedRoute>
            <PayrollReports />
          </ProtectedRoute>
        ),
      },
      {
        path: "finance/bursary-allocations",
        element: (
          <ProtectedRoute>
            <BursaryGiantsManagement financeOnly />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default financeRoutes;
